import { newMathFormat, isEmpty } from '@intelligence/utils/commonUtils';
import {
  // 参与程序筛选器
  ENGAGELEVEL_SEGEMENT,
} from '@intelligence/components/Filter/FilterBase/_config';
import type { IDataSourceMetric } from '@intelligence/types/common';
import type { SteamGamesDetailsOverlapRanksFetchParams } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/OverlapSteam/types';
import { REGION_OPTIONS_CONFIG } from '@intelligence/components/RegionCountrySelector/config';
// import { mock_data } from '@intelligence/components/RegionCountrySelector/mock';
import { RegionType } from '@intelligence/components/RegionCountrySelector/components/RegionTypeSelector';
import { MutableRefObject } from 'react';
import { US_COUNTRY_VALUE } from '@intelligence/components/RegionCountrySelector/RegionCountrySelector';

export const getInitialFetchParams = (
  isOperate: boolean,
  filterExtend: any,
  defaultFetchParams: SteamGamesDetailsOverlapRanksFetchParams,
): SteamGamesDetailsOverlapRanksFetchParams => {
  if (!isOperate) return defaultFetchParams;

  /** 参与程度筛选器参数 **/
  // const engagementLevelExtend = filterExtend?.[ENGAGELEVEL_SEGEMENT];
  // const engagementLevelTimes = engagementLevelFilterExtendTimes || engagementLevelDefaultTimes;
  /** 参与程度筛选器参数 **/

  return {
    ...defaultFetchParams,
  };
};

// export const calcTopRanksMetrics = (ranks: IMobileDetailsOverlapRank[]): IMobileDetailsOverlapTopRanksMetrics => {
//   if (!Array.isArray(ranks)) return {};
//   const result: IMobileDetailsOverlapTopRanksMetrics = {};
//   for (const metric of SORTABLE_METRICS) {
//     if (!metric) continue;
//     // 这里排序一定要新建数组排序，避免影响原数组的排序
//     const descOrderRanks = [...ranks].sort((a, b) => {
//       const aMetric = a?.metric_list?.find((item) => item?.metric === metric);
//       const bMetric = b?.metric_list?.find((item) => item?.metric === metric);
//       const aMetricValue = Number.parseFloat(aMetric?.value as any);
//       const bMetricValue = Number.parseFloat(bMetric?.value as any);
//       return numberComparator(aMetricValue, bMetricValue, false);
//     });
//     result[metric] = descOrderRanks.slice(0, 10).map((item) => item?.id);
//   }
//   return result;
// };

export const formatPercentNum = (num: any, ifNeedPercent = false): string => {
  let numTmp: any = Number.parseFloat(num);
  if (Number.isNaN(numTmp)) return '-';
  numTmp = (ifNeedPercent ? numTmp * 100 : numTmp).toFixed(2);
  return `${numTmp}%`;
};

export const formatPercentNumX = (num: any, ifNeedPercent = false): string => {
  let numTmp: any = Number.parseFloat(num);
  if (Number.isNaN(numTmp)) return '-';
  numTmp = (ifNeedPercent ? numTmp * 100 : numTmp).toFixed(2);
  return `${numTmp}x`;
};

export const handleMetrics = (metrics: IDataSourceMetric[]): IDataSourceMetric[] => {
  if (!Array.isArray(metrics)) return [];
  return metrics.map((metric) => {
    if (metric?.metric !== 'cross_app_usage') return metric;
    const metricValueNum = Number.parseFloat(metric?.value as any);
    return {
      ...metric,
      value: metricValueNum * 100,
    };
  });
};

const METRICS_FORMATTERS: {
  [key: string]: Function;
} = {
  cross_app_usage: formatPercentNum,
  cross_affinity: (value: any) => {
    const valueTmp = newMathFormat(value, true);
    return valueTmp && valueTmp !== '-' ? `${valueTmp}x` : valueTmp;
  },
};
const getMetricFormatter = (metric?: string): Function | null => {
  if (!metric) return null;
  return METRICS_FORMATTERS[metric] || null;
};
export const formatMetricValue = (metricKey?: string, metricValue?: any): any => {
  const formatter = getMetricFormatter(metricKey);
  const formatterValue = formatter?.(metricValue) || metricValue;
  return isEmpty(formatterValue) ? '-' : formatterValue;
};
export const formatYAxisLabel = (metric: string, value: any): string => {
  if (metric === 'cross_app_usage') return `${value}%`;
  if (metric === 'cross_affinity') return `${value}k`;
  return value;
};

// 根据后端返回数据获取 region options
export const getRegionOptions = () => {
  return REGION_OPTIONS_CONFIG;
};

// 根据后端返回数据获取国家地区配置数据
export const getCountryOptionConfig = (markets?: string[], allRegionOptionConfig?: any[]) => {
  if (!markets?.length || !allRegionOptionConfig?.length) return [];

  const marketsSet = new Set(
    markets
      .map((item: any) => item?.market)
      .filter(Boolean)
      .map((market: string) => String(market).toUpperCase()),
  );

  // 从所有地区配置中获取当前有数据的国家地区
  let currentRegionOptionConfig = allRegionOptionConfig?.map((region: any) => {
    const { country_set: countrySet } = region || {};
    const countries = countrySet.filter((country: any) => (
      marketsSet.has(String(country?.country_code || '').toUpperCase())
    ));
    return {
      ...region,
      country_set: countries,
    };
  });

  // 过滤掉无可用数据国家的地区
  currentRegionOptionConfig = currentRegionOptionConfig?.filter((region: any) =>
    Boolean(region?.country_set?.length),
  );

  return currentRegionOptionConfig || [];
};

// 根据国家\地区获取当前 level
export const currentRegionCountryLevel = () => {};

// 获取 region\market level map
type TLevelMapData = {
  level_a: string[];
  level_b: string[];
  market: string;
  region: string;
}[];

export type TLevelMap = Record<string, { level_a: string; level_b: string }>;

export type TPlayedWishlistedLevelMap = {
  played: TLevelMap;
  wishlisted: TLevelMap;
};

// 获取 region market 对应的 level map
export const getLevelMap = (data: TLevelMapData, regionType: 'market' | 'region') => {
  const map: TLevelMap = {};

  data?.forEach((item) => {
    map[item?.[regionType]] = {
      level_a: item.level_a?.includes('2h') ? '2h' : 'all',
      level_b: item.level_b?.includes('2h') ? '2h' : 'all',
    };
  });

  return map;
};

interface ICurrentValidEngagementLevelProps {
  currentRegionType: string;
  region: string;
  pageName: 'played' | 'wishlisted';
  regionsLevelMapRef: MutableRefObject<TPlayedWishlistedLevelMap | undefined>;
  marketsLevelMapRef: MutableRefObject<TPlayedWishlistedLevelMap | undefined>;
}

// 获取当前国家地区有数据的 level
export const currentValidEngagementLevel = ({
  currentRegionType,
  region,
  pageName,
  regionsLevelMapRef,
  marketsLevelMapRef,
}: ICurrentValidEngagementLevelProps) => {
  const engagementLevelA =
    currentRegionType === RegionType.region
      ? regionsLevelMapRef.current?.[pageName]?.[region]?.level_a
      : marketsLevelMapRef.current?.[pageName]?.[region]?.level_a;

  const engagementLevelB =
    currentRegionType === RegionType.region
      ? regionsLevelMapRef.current?.[pageName]?.[region]?.level_b
      : marketsLevelMapRef.current?.[pageName]?.[region]?.level_b;

  return { engagementLevelA, engagementLevelB };
};

// 获取当前配置中可用的国家选项
export const getCurrentValidMarket = (marketListConfig: any, region: string) => {
  const marketList = marketListConfig
    ?.map((item: { market: string }) => item?.market)
    // 移除 countries 中 global 相关
    ?.filter((market: string) => market !== 'global');

  const isValidValue = marketList?.includes(region);
  if (isValidValue) return region;

  const isHasUSValue = marketList?.includes(US_COUNTRY_VALUE);
  if (isHasUSValue) return US_COUNTRY_VALUE;

  // 既无有效值也无 US，使用默认第一项(无数据时返回 us，避免返回空默认有 global 数据导致宽表与国家筛选器对不上)
  return marketList?.[0] || US_COUNTRY_VALUE;
};
